import { send } from "../../utils/http";
import { markWelcomeIntroSeenEndPoint } from "../endPoints";

export const markWelcomeIntroSeen = async (version) => {
    return send(markWelcomeIntroSeenEndPoint, { version });
};
